import {
  MemberSortColumn,
  MemberSortDirection,
  OrganizationMember,
} from '@/types';

export const searchMembers = (
  searchPhrase: string,
  data: OrganizationMember[],
) => {
  if (searchPhrase.trim() === '') {
    return data;
  }

  return data.filter(m =>
    [m.name, m.userEmail, m.organizationEmail].some(v =>
      v?.toString().toLowerCase().includes(searchPhrase.trim().toLowerCase()),
    ),
  );
};

export const sortMembersFactory =
  (sortColumn: MemberSortColumn, sortDirection: MemberSortDirection) =>
  (a: OrganizationMember, b: OrganizationMember) => {
    const aValue = a[sortColumn];
    const bValue = b[sortColumn];

    if (aValue === null || aValue === undefined) return 1;
    if (bValue === null || bValue === undefined) return -1;

    const comparison = aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
    return (
      comparison *
      (sortDirection === 'asc' ? 1 : -1) *
      (sortColumn === 'lastActivityDate' ? -1 : 1)
    );
  };
